import React from 'react';
import styles from '@components/organisms/catalog/components/product-card/product-card.module.scss';
import { useTranslation } from 'next-i18next';

export interface ProductCardDutiesTagProps {
  showTooltip: boolean;
}

const ProductCardDutiesTag: React.FC<ProductCardDutiesTagProps> = ({ showTooltip }) => {
  const { t } = useTranslation();

  const tagClassName = styles.productCard__dutiesApply;
  const tagCyTestID = 'product_card_duties_tag';
  const tagContent = t('CATALOG.DUTIES.PRODUCT_CARD.TAG');

  if (showTooltip) {
    // This is an anchor tag to comply with react-tooltip

    return (
      <a
        className={tagClassName}
        data-tooltip-id="highlight-duties-tooltip"
        data-cy={tagCyTestID}
      >
        {tagContent}
      </a>
    );
  }

  return (
    <span
      className={tagClassName}
      data-cy={tagCyTestID}
    >
      {tagContent}
    </span>
  );
};

export default ProductCardDutiesTag;
